import {
  ChangeDetectionStrategy,
  Component,
  computed,
  Inject,
} from '@angular/core';
import { Store } from '@ngxs/store';
import {
  TuiButtonModule,
  TuiDataListModule,
  TuiTextfieldControllerModule,
} from '@taiga-ui/core';

import { Router, RouterLink } from '@angular/router';
import { AuthState } from '@store/auth/auth.state';
import { FormsModule } from '@angular/forms';
import { TuiSelectModule } from '@taiga-ui/kit';
import { TuiLetModule } from '@taiga-ui/cdk';
import { NgForOf } from '@angular/common';
import { WINDOW } from '@shared/providers/window.provider';
import { TranslocoPipe } from '@jsverse/transloco';
import { UserMenuComponent } from './components/user-menu/user-menu.component';
import { MENU_ITEMS, MenuItem } from './menu';
import { RouteNames } from '../../route-names';
import { DropdownMenuComponent } from './components/dropdown-menu/dropdown-menu.component';
import { DivisionSelectComponent } from '../components/division-select/division-select.component';
import { LanguageSelectComponent } from '../components/language-select/language-select.component';

@Component({
  selector: 'app-navbar',
  standalone: true,
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss',
  imports: [
    TuiButtonModule,
    RouterLink,
    UserMenuComponent,
    TuiDataListModule,
    FormsModule,
    TuiSelectModule,
    TuiTextfieldControllerModule,
    TuiLetModule,
    NgForOf,
    DropdownMenuComponent,
    DivisionSelectComponent,
    TranslocoPipe,
    LanguageSelectComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavbarComponent {
  isAuthenticated = this.store.selectSignal(AuthState.isAuthenticated);
  availableMenuItems = computed(() => {
    return MENU_ITEMS;
  });

  protected readonly MENU_ITEMS = MENU_ITEMS;
  protected readonly RouteNames = RouteNames;
  constructor(
    @Inject(WINDOW) private readonly window: Window,
    private readonly store: Store,
    private readonly router: Router,
  ) {}

  navigate({ blank, path }: MenuItem) {
    if (blank) {
      this.window.open(path, '_blank');
    } else {
      this.router.navigate([path]);
    }
  }
}
